<template>
  <div :class="classes">
    <input
      :id="cmpId"
      v-bind="inputAttrs"
      :checked="isChecked"
      class="custom-control-input"
      :disabled="disabled"
      type="radio"
      :value="value"
    >

    <div>
      <label
        v-if="hasLabel"
        class="custom-control-label"
        :for="cmpId"
      >
        {{ label }}
        <slot/>
      </label>

      <div
        v-if="helpBlock"
        :id="ariaDescribedBy"
        class="form-text small"
      >
        {{ helpText }}
      </div>

      <!-- @slot Space for overriding custom validation feedback -->
      <slot name="validationFeedback">
        <div
          v-if="validationFeedbackText"
          :class="validationFeedbackClass"
        >
          {{ validationFeedbackText }}
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import { SIZE_MD } from '../../config/constants';
import formControl from '../../mixins/form-control';
import formControlCheck from '../../mixins/form-control-check';
import { RADIO_BASE_CLASS, RADIO_SIZES } from './config';

export default {
  name: 'DpRadio',

  compatConfig: { MODE: 3 },

  mixins: [formControlCheck, formControl],

  props: {
    modelValue: {
      required: true,
      type: [Boolean, Number, String],
      default: null,
    },
    /**
     * @values md, lg
     * @default md
     * */
    size: {
      required: false,
      type: String,
      default: SIZE_MD,
      validator: (value) => RADIO_SIZES.includes(value),
    },
  },

  emits: [
    'update:modelValue',
  ],

  computed: {
    classes() {
      const classes = [
        RADIO_BASE_CLASS,
        this.validationClass,
      ];

      if (this.size !== SIZE_MD) {
        classes.push(`custom-control-${this.size}`);
      }

      if (this.inline) {
        classes.push('custom-control-inline');
      }

      return classes;
    },

    isChecked() {
      return this.modelValue === this.value;
    },
  },

  methods: {
    change() {
      /**
       * Emits selected value
       *
       * @type {text}
       */
      this.$emit('update:modelValue', this.value);
    },
  },
};
</script>
